import { gql } from '@apollo/client';

export const DOCUMENT_FRAGMENT = gql`
  fragment DocumentFragment on Document {
    id
    filename
    filepickerUrl
  }
`;
